import EventScheduleService from 'src/modules/eventSchedule/eventScheduleService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'EVENTSCHEDULE_FORM';

const eventScheduleFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventScheduleFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EventScheduleService.find(id);
      }

      dispatch({
        type: eventScheduleFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventScheduleFormActions.INIT_ERROR,
      });

      getHistory().push('/event-schedule');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: eventScheduleFormActions.CREATE_STARTED,
      });

      await EventScheduleService.create(values);

      dispatch({
        type: eventScheduleFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventSchedule.create.success'),
      );

      getHistory().push('/event-schedule');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventScheduleFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: eventScheduleFormActions.UPDATE_STARTED,
      });

      await EventScheduleService.update(id, values);

      dispatch({
        type: eventScheduleFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventSchedule.update.success'),
      );

      getHistory().push('/event-schedule');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventScheduleFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default eventScheduleFormActions;
